import React, { useEffect } from 'react';

import TeamcenterCards from './TeamcenterCards';
import CentermanufacturingBanner from './CentermanufacturingBanner';
import DigitalManufactuirngCards from './DigitalManufactuirngCards';
const Casestudiesteamcenterpage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []); // Empty dependency array ensures it only runs once when the component mounts
    // Scroll to the top of the page when the component mounts

    return (
        <div style={{ backgroundColor: '#fff' }}>
            <CentermanufacturingBanner />
            {/* <CasedigitalmarketingBanner /> */}
            {/* <DigitalManufactuirngCards /> */}
             <TeamcenterCards />

        </div>
    );
};

export default Casestudiesteamcenterpage;
